import { render } from "./App.vue?vue&type=template&id=9b5f7844"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9b5f7844&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__